'use client';

import { c as _c } from "react/compiler-runtime";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import ImageBox from '../../ImageBox';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { top_left_lottie } from '../interactive/paths';
import { useState, useMemo, useRef, useCallback, useEffect } from 'react';
import AnimationComponent from '../interactive/AnimationComponent';
import { cx } from '@/src/styles/stylebook';
import { fmtKST } from '@/src/utils/dateUtils';
import { motion, AnimatePresence } from 'framer-motion';
import Link from 'next/link';
import GooeyFilter from '../filter/GooeyFilter';
const SpotlightCarousel = t0 => {
  const $ = _c(36);
  const {
    data
  } = t0;
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const currentSlide = data[currentSlideIndex];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Map();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const titleMotionRefs = useRef(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Map();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const descMotionRefs = useRef(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [heights, setHeights] = useState(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = elementKey => {
      const titleElement = titleMotionRefs.current.get(elementKey);
      const descElement = descMotionRefs.current.get(elementKey);
      if (titleElement || descElement) {
        requestAnimationFrame(() => {
          setHeights(prev => ({
            ...prev,
            [elementKey]: (titleElement || descElement)?.scrollHeight || 0
          }));
        });
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const measureHeight = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const resizeObserver = new ResizeObserver(entries => {
        entries.forEach(entry => {
          const element = entry.target;
          const elementKey_0 = element.dataset.elementKey || "";
          if (elementKey_0) {
            measureHeight(elementKey_0);
          }
        });
      });
      titleMotionRefs.current.forEach(element_0 => {
        if (element_0) {
          resizeObserver.observe(element_0);
        }
      });
      descMotionRefs.current.forEach(element_1 => {
        if (element_1) {
          resizeObserver.observe(element_1);
        }
      });
      return () => {
        resizeObserver.disconnect();
      };
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== currentSlideIndex) {
    t6 = [currentSlideIndex, measureHeight];
    $[5] = currentSlideIndex;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  useEffect(t5, t6);
  const getAnimationConfig = _temp;
  currentSlide?.spotlight;
  let t7;
  const t8 = currentSlide?.spotlight;
  let t9;
  if ($[7] !== t8) {
    t9 = getAnimationConfig(t8);
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  t7 = t9;
  const animationConfig = t7;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      clickable: true,
      el: ".custom-pagination",
      bulletClass: "custom-bullet opacity-30",
      bulletActiveClass: "custom-bullet-active opacity-100",
      renderBullet: _temp2
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const pagination = t10;
  let t11;
  let t12;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [Pagination, Navigation, Autoplay];
    t12 = {
      delay: 5000,
      disableOnInteraction: false
    };
    $[10] = t11;
    $[11] = t12;
  } else {
    t11 = $[10];
    t12 = $[11];
  }
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      nextEl: ".custom-next",
      prevEl: ".custom-prev"
    };
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = swiper => {
      setCurrentSlideIndex(swiper.realIndex);
    };
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== data) {
    t15 = data.map(_temp3);
    $[14] = data;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t15) {
    t16 = <Swiper modules={t11} autoplay={t12} pagination={pagination} navigation={t13} slidesPerView={1} direction="horizontal" loop={true} className="spotlight-carousel h-full w-full" onSlideChange={t14}>{t15}</Swiper>;
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  const t17 = !!currentSlide?.spotlight;
  let t18;
  if ($[18] !== animationConfig.direction || $[19] !== animationConfig.endFrame || $[20] !== animationConfig.startFrame || $[21] !== t17) {
    t18 = <div className="pointer-events-none absolute top-0 left-0 z-1 block h-full w-full"><AnimationComponent animationData={top_left_lottie} startFrame={animationConfig.startFrame} endFrame={animationConfig.endFrame} direction={animationConfig.direction} play={t17} autoplay={false} preserveAspectRatio="none" renderer="canvas" className="h-full w-full" /></div>;
    $[18] = animationConfig.direction;
    $[19] = animationConfig.endFrame;
    $[20] = animationConfig.startFrame;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== currentSlide || $[24] !== currentSlideIndex || $[25] !== heights) {
    t19 = currentSlide && <motion.div className={cx("pointer-events-auto absolute z-15 flex flex-col gap-2", currentSlide?.spotlight?.includes("left") ? "items-end" : "items-start", currentSlide?.spotlight?.includes("top") ? currentSlide?.spotlight === "top-right" ? "top-[calc(1.875rem+var(--spacing-gutter)*2)] max-md:top-[calc(57px+var(--spacing-gutter)*2)]" : "top-[var(--headerh)] max-md:top-[calc(57px+var(--spacing-marg)*1)]" : "", currentSlide?.spotlight?.includes("right") ? "left-marg" : "right-gutter", currentSlide?.spotlight?.includes("bottom") ? "bottom-[1.875rem]" : "")}><div className="title-wrapper flex flex-col">{currentSlide.title?.split("\n").map((titleLine, lineIndex) => {
          const titleKey = `title_${currentSlideIndex}_${lineIndex}`;
          return <div key={titleKey} className="w-full overflow-hidden" style={{
            height: heights[titleKey] || "auto"
          }}><motion.h1 ref={el => {
              if (el) {
                titleMotionRefs.current.set(titleKey, el);
                measureHeight(titleKey);
              }
            }} data-element-key={titleKey} className={cx("leading-tight", currentSlide?.spotlight === "top-left" ? "text-right" : "text-left")} initial={{
              y: "130%"
            }} animate={{
              y: 0
            }} exit={{
              y: "130%"
            }} transition={{
              duration: 0.6,
              ease: "easeInOut",
              delay: lineIndex * 0.05
            }}>{titleLine}</motion.h1></div>;
        })}</div><div className={cx("description-wrapper bold flex flex-col capitalize", currentSlide?.spotlight?.includes("left") ? "text-right" : "text-left")}>{[currentSlide?.category !== "none" && currentSlide.category, currentSlide.date && fmtKST(new Date(currentSlide.date || ""), "yyyy/MM/dd")].filter(Boolean).join(" \xB7 ").split("\n").map((descLine, lineIndex_0) => {
          const descKey = `desc_${currentSlideIndex}_${lineIndex_0}`;
          const titleLinesCount = currentSlide.title?.split("\n").length || 0;
          return <div key={descKey} className="w-full overflow-hidden" style={{
            height: heights[descKey] || "auto"
          }}><motion.p ref={el_0 => {
              if (el_0) {
                descMotionRefs.current.set(descKey, el_0);
                measureHeight(descKey);
              }
            }} data-element-key={descKey} className="leading-tight" initial={{
              y: "130%"
            }} animate={{
              y: 0
            }} exit={{
              y: "130%"
            }} transition={{
              duration: 0.6,
              ease: "easeInOut",
              delay: titleLinesCount * 0.05 + lineIndex_0 * 0.05
            }}>{descLine}</motion.p></div>;
        })}</div>{currentSlide.link && <Link href={currentSlide.link} className={cx("bg-gray-0 bold mt-4 flex w-fit items-center justify-center px-3 pt-0.5 text-green-50")}>View →</Link>}</motion.div>;
    $[23] = currentSlide;
    $[24] = currentSlideIndex;
    $[25] = heights;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t19) {
    t20 = <div className="pointer-events-none absolute inset-0 z-15 h-full w-full"><AnimatePresence mode="wait">{t19}</AnimatePresence></div>;
    $[27] = t19;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="!bottom-gutter !left-marg absolute z-30"><div className="custom-pagination flex gap-3" /><GooeyFilter className="pointer-events-none absolute -top-4 -right-4 -bottom-4 -left-4" /></div>;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <button className="custom-prev rounded-full text-white transition-colors hover:bg-black/5"><svg width="48" height="48" viewBox="0 0 48 48" fill="none"><path d="M35.54 2.49216C36.6058 1.91247 37.8912 1.84501 39.3945 2.28904C40.8525 2.7197 41.8819 3.47127 42.4844 4.54392C43.0887 5.61702 43.1683 6.9039 42.7236 8.40916C42.293 9.86689 41.5298 10.893 40.4326 11.4883C39.4835 12.0058 38.4 12.1366 37.1797 11.8828C37.026 11.9775 36.863 12.0578 36.6895 12.122C36.4317 13.3194 35.8836 14.2456 35.042 14.9013C34.1526 15.5975 33.0492 15.9003 31.7295 15.8144C31.5542 15.9965 31.3564 16.1598 31.1338 16.3027C30.8426 16.4896 30.5184 16.6172 30.1631 16.6875C30.1167 16.8383 30.0661 16.9917 30.0078 17.1465C29.472 18.5689 28.6366 19.5371 27.499 20.0508C26.5893 20.4639 25.5887 20.5383 24.4961 20.2773C24.1222 20.9568 23.5888 21.4405 22.8896 21.7324C22.5709 21.8654 22.2305 21.9348 21.8691 21.9424C21.7977 22.0817 21.7224 22.2231 21.6387 22.3642C21.2206 23.0693 20.7375 23.6266 20.1934 24.041C20.2067 24.1398 20.2174 24.2404 20.2266 24.3428C20.7574 24.7545 21.2289 25.305 21.6387 25.9961C21.7223 26.1371 21.7988 26.2778 21.8701 26.417C22.2311 26.4247 22.5712 26.495 22.8896 26.6279C23.5885 26.9197 24.1222 27.4028 24.4961 28.082C25.5886 27.8211 26.5894 27.8965 27.499 28.3095C28.6365 28.8233 29.472 29.7914 30.0078 31.2138C30.0662 31.3688 30.1177 31.5219 30.1641 31.6728C30.5191 31.7432 30.8428 31.8709 31.1338 32.0576C31.356 32.2002 31.5535 32.3633 31.7285 32.5449C33.0485 32.4589 34.1524 32.7619 35.042 33.458C35.8832 34.1134 36.4306 35.0398 36.6885 36.2363C36.8624 36.3006 37.0256 36.3816 37.1797 36.4765C38.4 36.2227 39.4836 36.3545 40.4326 36.872C41.5299 37.4673 42.293 38.4933 42.7236 39.9511C43.1683 41.4565 43.0888 42.7432 42.4844 43.8164C41.8819 44.889 40.8525 45.6406 39.3945 46.0713C37.8913 46.5153 36.6058 46.4478 35.54 45.8681C34.4741 45.2884 33.7191 44.2475 33.2744 42.7422C33.2495 42.6578 33.2256 42.5743 33.2041 42.4912C33.1544 42.4575 33.1045 42.4223 33.0557 42.3857C33.0167 42.3565 32.9778 42.327 32.9404 42.2959C32.8 42.3214 32.6563 42.3441 32.5088 42.3623C30.9528 42.5537 29.6956 42.2771 28.7393 41.5303C27.7829 40.7835 27.2093 39.6331 27.0176 38.0752C27.013 38.0379 27.0099 38.0007 27.0059 37.9638C26.904 37.8835 26.8073 37.7964 26.7158 37.7021C25.4208 38.1104 24.2737 38.0911 23.2744 37.6386C22.1691 37.1382 21.3404 36.1554 20.7871 34.6865C20.6206 34.2445 20.5037 33.8168 20.4365 33.4033C20.3276 33.3693 20.2186 33.3303 20.1104 33.2851C19.9046 33.1992 19.7111 33.0893 19.5283 32.958C18.3236 33.5863 17.1902 33.7667 16.127 33.4951C14.9513 33.1948 13.9637 32.3716 13.1631 31.0215C12.9498 30.6618 12.7773 30.3062 12.6445 29.9551L9.93066 29.9521C8.36303 29.9521 7.149 29.5106 6.29102 28.6289C5.43302 27.7452 5.00391 26.5456 5.00391 25.0254C5.00391 23.4578 5.43313 22.2447 6.29102 21.3867C7.14901 20.5287 8.36297 20.0986 9.93066 20.0986L12.3164 20.1006C12.3181 19.2093 12.5995 18.2882 13.1631 17.3379C13.9637 15.9878 14.9514 15.1645 16.127 14.8642C17.1899 14.5928 18.3239 14.7724 19.5283 15.4004C19.7109 15.2693 19.905 15.1609 20.1104 15.0752C20.2188 15.0299 20.3274 14.9891 20.4365 14.9551C20.5038 14.5422 20.6209 14.1151 20.7871 13.6738C21.3404 12.2049 22.1691 11.2221 23.2744 10.7217C24.2738 10.2691 25.4215 10.2487 26.7168 10.6572C26.8078 10.5636 26.9036 10.4764 27.0049 10.3965C27.0089 10.3595 27.013 10.3224 27.0176 10.2851C27.2093 8.72726 27.783 7.57682 28.7393 6.83006C29.6956 6.08323 30.9528 5.8056 32.5088 5.99705C32.6563 6.01519 32.8 6.03793 32.9404 6.06345C32.9778 6.03236 33.0167 6.00287 33.0557 5.97361C33.1046 5.93693 33.1543 5.90191 33.2041 5.86814C33.2256 5.78517 33.2495 5.70137 33.2744 5.61716C33.7191 4.11198 34.4742 3.07188 35.54 2.49216Z" fill="black" /></svg></button>;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="bottom-gutter right-gutter absolute z-20 flex gap-4">{t22}<button className="custom-next z-20 rounded-full text-white transition-colors hover:bg-black/5"><svg width="49" height="48" viewBox="0 0 49 48" fill="none"><path d="M8.64314 2.28911C10.1466 1.84501 11.4327 1.91241 12.4986 2.49224C13.5645 3.07201 14.3186 4.11286 14.7633 5.61821C14.788 5.70185 14.8112 5.78482 14.8326 5.86724C14.8828 5.90126 14.9327 5.9367 14.982 5.97368C15.0209 6.00284 15.059 6.03351 15.0963 6.0645C15.2372 6.03885 15.3818 6.01533 15.5299 5.99712C17.0855 5.8058 18.3422 6.08353 19.2984 6.83013C20.2548 7.57689 20.8294 8.72727 21.0211 10.2852C21.0256 10.3224 21.0278 10.3597 21.0318 10.3965C21.1333 10.4766 21.2297 10.5634 21.3209 10.6573C22.6162 10.2487 23.7638 10.2693 24.7633 10.7217C25.8686 11.2222 26.6973 12.2049 27.2506 13.6739C27.4168 14.1152 27.5329 14.5423 27.6002 14.9551C27.7097 14.9892 27.8185 15.0298 27.9273 15.0752C28.1326 15.161 28.3268 15.2695 28.5093 15.4004C29.714 14.7722 30.8485 14.5927 31.9117 14.8643C33.0873 15.1646 34.0739 15.9888 34.8746 17.3389C35.0876 17.6982 35.2594 18.0535 35.3922 18.4043L38.108 18.4083C39.6756 18.4083 40.8897 18.8498 41.7476 19.7315C42.6055 20.6151 43.0347 21.8149 43.0347 23.335C43.0347 24.9024 42.6054 26.1157 41.7476 26.9737C40.8897 27.8316 39.6756 28.2617 38.108 28.2618L35.7213 28.2588C35.7198 29.1503 35.4382 30.071 34.8746 31.0215C34.074 32.3716 33.0872 33.1948 31.9117 33.4952C30.8482 33.7669 29.7143 33.5866 28.5093 32.9581C28.3266 33.0893 28.133 33.1994 27.9273 33.2852C27.8186 33.3306 27.7096 33.3703 27.6002 33.4043C27.5329 33.8175 27.4169 34.2449 27.2506 34.6866C26.6973 36.1555 25.8686 37.1383 24.7633 37.6387C23.7635 38.0913 22.6157 38.1112 21.3199 37.7022C21.2292 37.7955 21.1337 37.8823 21.0328 37.962C21.0287 37.9995 21.0257 38.0374 21.0211 38.0752C20.8294 39.6332 20.2548 40.7836 19.2984 41.5303C18.3422 42.2769 17.0854 42.5546 15.5299 42.3633C15.3818 42.3451 15.2372 42.3206 15.0963 42.295C15.0588 42.3261 15.021 42.3575 14.982 42.3868C14.9328 42.4236 14.8827 42.4583 14.8326 42.4922C14.8111 42.575 14.7881 42.6583 14.7633 42.7422C14.3186 44.2476 13.5645 45.2884 12.4986 45.8682C11.4327 46.448 10.1466 46.5154 8.64314 46.0713C7.18535 45.6407 6.15577 44.889 5.55329 43.8165C4.94904 42.7434 4.86942 41.4564 5.31404 39.9512C5.74467 38.4934 6.50793 37.4674 7.60505 36.8721C8.55401 36.3546 9.63781 36.2229 10.858 36.4766C11.012 36.3817 11.1753 36.3007 11.3492 36.2364C11.6071 35.0399 12.1545 34.1134 12.9957 33.4581C13.8852 32.7619 14.9893 32.459 16.3092 32.545C16.4843 32.3631 16.6824 32.2004 16.9049 32.0577C17.196 31.8709 17.5194 31.7423 17.8746 31.6719C17.9209 31.5214 17.9717 31.3684 18.0299 31.2139C18.5657 29.7913 19.4019 28.8233 20.5396 28.3096C21.4489 27.8967 22.4486 27.8216 23.5406 28.0821C23.9145 27.4025 24.4498 26.9198 25.149 26.628C25.4672 26.4952 25.8068 26.4248 26.1676 26.417C26.239 26.2777 26.3163 26.1373 26.4 25.9961C26.8181 25.2911 27.2993 24.7318 27.8433 24.3174C27.83 24.2186 27.8193 24.118 27.8101 24.0157C27.28 23.604 26.8093 23.0545 26.4 22.3643C26.3162 22.223 26.24 22.0819 26.1685 21.9424C25.8074 21.9348 25.4675 21.8654 25.149 21.7325C24.4496 21.4405 23.9146 20.9573 23.5406 20.2774C22.4485 20.538 21.4489 20.4638 20.5396 20.0508C19.4019 19.5372 18.5657 18.5691 18.0299 17.1465C17.9714 16.9913 17.92 16.8378 17.8736 16.6866C17.5188 16.6162 17.1957 16.4884 16.9049 16.3018C16.6824 16.159 16.4843 15.9963 16.3092 15.8145C14.9892 15.9005 13.8852 15.5976 12.9957 14.9014C12.1545 14.2459 11.607 13.3198 11.3492 12.1231C11.1753 12.0587 11.012 11.9778 10.858 11.8829C9.63774 12.1366 8.55406 12.0059 7.60505 11.4883C6.50793 10.8931 5.74467 9.86699 5.31404 8.40923C4.86943 6.90405 4.94907 5.61706 5.55329 4.544C6.15577 3.47143 7.18536 2.71979 8.64314 2.28911Z" fill="black" /></svg></button></div>;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t16 || $[33] !== t18 || $[34] !== t20) {
    t24 = <div className="relative h-[calc(var(--svh)-var(--popup))] w-full">{t16}{t18}{t20}{t21}{t23}</div>;
    $[32] = t16;
    $[33] = t18;
    $[34] = t20;
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  return t24;
};
export default SpotlightCarousel;
function _temp(spotlight) {
  switch (spotlight) {
    case "top-left":
      {
        return {
          startFrame: 0,
          endFrame: 29,
          direction: 1
        };
      }
    case "top-right":
      {
        return {
          startFrame: 24,
          endFrame: 0,
          direction: -1
        };
      }
    case "bottom-left":
      {
        return {
          startFrame: 29,
          endFrame: 0,
          direction: -1
        };
      }
    case "bottom-right":
      {
        return {
          startFrame: 29,
          endFrame: 0,
          direction: 1
        };
      }
    default:
      {
        return {
          startFrame: 0,
          endFrame: 0,
          direction: 1
        };
      }
  }
}
function _temp2(index, className) {
  return `<span class="${className} w-5 h-5 block ">
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="#000"
        style="width:100%; height:100%;"
      >
        <path d="M4.16417 26.9211C6.94035 29.638 10.7176 31 15.4999 31C20.4341 31 24.2513 29.638 26.9514 26.9211C29.648 24.2005 31 20.3546 31 15.3835C31 10.5652 29.648 6.79588 26.9514 4.07895C24.2513 1.35836 20.4341 0 15.4999 0C10.7176 0 6.94035 1.35836 4.16417 4.07895C1.388 6.79588 0 10.5652 0 15.3835C0 20.3546 1.388 24.2005 4.16417 26.9211Z" />
      </svg>
    </span>`;
}
function _temp3(slide, index_0) {
  return <SwiperSlide key={index_0}><div className="h-full w-full"><ImageBox image={slide.image} classesWrapper={`absolute top-0 left-0 h-full w-full ${slide.mobileImage ? "aspect-w-block-only" : ""}`} placeholder="blur" pixelatedLoading={true} />{slide.mobileImage && <ImageBox image={slide.mobileImage} classesWrapper="absolute top-0 left-0 h-full w-full aspect-h-block-only" placeholder="blur" pixelatedLoading={true} />}</div></SwiperSlide>;
}